import { useEffect, useRef } from 'react';
import type { Chart } from 'chart.js';
import { buildTrendChart, buildZoneChart } from './charts';
import type { Period, Row } from './lib';

export function TrendChart({ rows, period }: { rows: Row[]; period: Period }) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const chartRef = useRef<Chart | null>(null);

  useEffect(() => {
    const ctx = canvasRef.current?.getContext('2d');
    if (!ctx) return;
    chartRef.current?.destroy();
    chartRef.current = buildTrendChart(ctx, rows, period);
    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, [rows, period]);

  return (
    <div className="chart-box chart-trend">
      <canvas ref={canvasRef} />
    </div>
  );
}

export function ZoneChart({ rows }: { rows: Row[] }) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const chartRef = useRef<Chart | null>(null);

  useEffect(() => {
    const ctx = canvasRef.current?.getContext('2d');
    if (!ctx) return;
    chartRef.current?.destroy();
    chartRef.current = buildZoneChart(ctx, rows);
    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, [rows]);

  return (
    <div className="chart-box chart-zone">
      <canvas ref={canvasRef} />
    </div>
  );
}
